export const getQualId = (qualification) => {
  let q = qualification.toLowerCase().trim();
  if (q === "a-level" || q === "alevel") {
    return 1;
  } else if (q === "ib") {
    return 2;
  } else if (q === "igcse") {
    return 3;
  } else if (q === "ielts" || q === "toefl" || q === "ielts / toefl") {
    return 4;
  } else if (q === "university admissions" || q === "uniadm") {
    return 5;
  } else {
    return 1;
  }
};
